import React, { 
  useEffect, 
  useState, 
  useRef 
} from "react";
// import { Image } from 'antd';
import "./CommonOrdering.css";
import "./MenuCategory.css";
import { Card, Col, Form, Row } from "react-bootstrap";
import { logoutUser } from "../../Helpers/apiCalls/authApi";

import {
  Button,
  Space,
  Modal,
  Input,
  // Select,
  // Badge,
  Spin,
} from "antd";
import Title from "antd/es/typography/Title";

import {
  EditOutlined,
  MinusCircleFilled,
  PlusCircleFilled,
} from "@ant-design/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { getAllCategories } from "../../Helpers/apiCalls/categoriesManagerApi";
import { getAllMenu } from "../../Helpers/apiCalls/MenuApi";
import trash from "../../Assets/Images/trash.png";
import AddBoxIcon from '@mui/icons-material/AddBox';
import {
  getRole,
  getZReading,
  numberWithCommas,
  toastStyle,
  isEmptyString,
  refreshPage,
  getOrderID,
  removeUserSession,
} from "../../Helpers/Utils/Common";
import { EditNoteOutlined } from "@mui/icons-material";

import { createOrderTakeout } from "../../Helpers/apiCalls/OrderApi";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import cc from "../../Assets/Images/money.png"
// import ci from "../../Assets/Images/cashierNavbar/invoice.png"
import drawer from "../../Assets/Images/drawer.png";
import logout from "../../Assets/Images/logout.png";
import { printOpenCashDrawer, printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import DispatchSlip from "../../Components/Print/DispatchSlip";
import html2canvas from "html2canvas";
import { recordUserActivityLog } from "../../Helpers/apiCalls/authApi";
// import { usePostRequest } from "../../Helpers/hooks/usePostRequest";

const { TextArea } = Input;
// const { Option } = Select;

export default function OrderingPage() {
// const {
//   callPost, 
//   // responseDatas
// } = usePostRequest(() => {})
  // const [loader, setLoader] = useState(false);
  const newOrderId = getOrderID();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [menu, setMenu] = useState([]);
  // const [printSlipsDone, setPrintSlipsDone] = useState(false);
  const [ws, setWs] = useState(null);
  const [menuCopy, setMenuCopy] = useState([]);
  const [menuCart, setMenuCart] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [grandTotalfd, setGrandTotalfd] = useState(0);
  const [grandTotalgrab, setGrandTotalgrab] = useState(0);
  const [priceType, setPriceType] = useState("store");
  const [categoryType, setCategoryType] = useState("");
  const [buzzer, setBuzzer] = useState("");
  const bulkPrintRefs = useRef([]);
  const [orderSlips, setOrderSlips] = useState({});
  // const orderRef = useRef();
  const [action, setAction] = useState("order");

  const [disableClick, setDisableClick] = useState(false);
  const [openRemarksModal, setOpenRemarksModal] = useState(false);
  const [openBuzzerModal, setOpenBuzzerModal] = useState(false);
  const [tempRemarks, setTempRemarks] = useState("");
  const [orderCartIndex, setOrderCartIndex] = useState(null);
  const [openModifier, setOpenModifier] = useState(false);
  const [modifierData, setModifierData] = useState([]);
  // const [orderCart, setOrderCart] = useState([]);
  const [modifierOrder, setModifierOrder] = useState({
    counter: 0,
    modifier: [],
  });

  const buzzerNumber = [
    {
      id: 1,
      name: "01"
    },
    {
      id: 2,
      name: "02"
    },
    {
      id: 3,
      name: "03"
    },
    {
      id: 4,
      name: "04"
    },
    {
      id: 5,
      name: "05"
    },
    {
      id: 6,
      name: "06"
    },
    {
      id: 7,
      name: "07"
    },
    {
      id: 8,
      name: "08"
    },
    {
      id: 9,
      name: "09"
    },
    {
      id: 10,
      name: "10"
    },
    {
      id: 11,
      name: "11"
    },
    {
      id: 12,
      name: "12"
    },
    {
      id: 13,
      name: "13"
    },
    {
      id: 14,
      name: "14"
    },
    {
      id: 15,
      name: "15"
    },
    {
      id: 16,
      name: "16"
    },
    {
      id: 17,
      name: "17"
    },
    {
      id: 18,
      name: "18"
    },
    {
      id: 19,
      name: "19"
    },
    {
      id: 20,
      name: "20"
    },
    {
      id: 21,
      name: "21"
    },
    {
      id: 22,
      name: "22"
    },
    {
      id: 23,
      name: "23"
    },
    {
      id: 24,
      name: "24"
    },
    {
      id: 25,
      name: "25"
    },
    {
      id: 26,
      name: "26"
    },
    {
      id: 27,
      name: "27"
    },
    {
      id: 28,
      name: "28"
    },
    {
      id: 29,
      name: "29"
    },
    {
      id: 30,
      name: "30"
    },
  ]

  async function handleLogout() {
    const response = await logoutUser();
    if (response.data) {
      toast.success("Logging out...")
      setTimeout(() => {
        removeUserSession();
        navigate("/");
        refreshPage();
      }, 500)
    }
}

  function renderTableOptions() {
    return (
      <Row className="w-100 mt-2 category-container product-only-container">
        {buzzerNumber?.map((table, index) => (
          <Col sm={2} key={index} align="center">
            <Card
              onClick={() => {
                if(parseInt(table.id) !== parseInt(buzzer.id)){
                  setBuzzer(table);
                }
              }}
              className={`mt-1 center 
                ${parseInt(table.id) === parseInt(buzzer.id) ? 'disable-table' : 'order-table-card'}
              `}
            >
              {table.name?.toUpperCase()}
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  function byThreeCards(arr) {
    const res = [];
    for (let i = 0; i < arr.length; i += 3) {
      const chunk = arr.slice(i, i + 3);
      res.push(chunk);
    }
    return res;
  }
  async function fetchCategories() {
    const response = await getAllCategories();
    if (response.data.data) {
      setCategories(response.data.data.categories);
      setCategoryType(response.data.data.categories[0].id);
      const response_menu = await getAllMenu();
      if (response_menu.data) {
        response_menu.data.data.menus.forEach((data) => {
          data.products.forEach((info) => {
            info.counter = 0;
            info.category_id = data.category_id;
            info.category_name = data.category_name;
          });
        });

        response_menu.data.data.menus.forEach((data) => {
          data.products.forEach((info) => {
            info.remarks.forEach((remark, index) => {
              info[remark + "_" + index] = false;
            });
          });
        });

        let result = [];
        response_menu.data.data.menus.forEach((a) => {
          if (a.category_name.includes(response.data.data.categories[0].name)) {
            result.push({
              category_id: a.category_id,
              category_name: a.category_name,
              products: byThreeCards(a.products),
            });
          }
        });
        setMenuCopy(response_menu.data.data.menus);
        setMenu(result);
      } else if (response_menu.error) {
      }
      // setLoader(false);
    }
  }

  async function filterMenu(id) {
    setCategoryType(id);
    let result = [];
    menuCopy.forEach((a) => {
      if (a.category_id === id) {
        result.push({
          category_id: a.category_id,
          category_name: a.category_name,
          products: byThreeCards(a.products),
        });
      }
    });
    setMenu(result);
  }

  const handleCounterChange = (
    newValue,
    index1,
    index2,
    index3,
    menuID,
    info
  ) => {
    newValue = parseInt(newValue);
    newValue = newValue < 0 ? 0 : newValue;
    const updatedCategory = [...menu];
    if (newValue > 0) {
      updatedCategory[index1].products[index2][index3].counter =
        newValue > 0 ? newValue : 0;
      setMenu(updatedCategory);

      const itemIndexInCart = menuCart.findIndex(
        (cartItem) => cartItem.id === menuID
      );
      if (itemIndexInCart === -1) {
        setMenuCart((prevCart) => [
          ...prevCart,
          {
            ...info,
            id: menuID,
            counter: newValue,
            pricelist: priceType,
          },
        ]);
      } else {
        if (newValue > 0) {
          const updatedCart = [...menuCart];
          updatedCart[itemIndexInCart].counter = newValue > 0 ? newValue : 0;
          setMenuCart(updatedCart);
        } else {
          const updatedCart = [...menuCart];
          updatedCart.splice(itemIndexInCart, 1);
          setMenuCart(updatedCart);
        }
      }
    } else {
      updatedCategory[index1].products[index2][index3].counter = "";
      setMenu(updatedCategory);
      const itemIndexInCart = menuCart.findIndex(
        (cartItem) => cartItem.id === menuID
      );
      if (itemIndexInCart !== -1) {
        const updatedCart = [...menuCart];
        updatedCart.splice(itemIndexInCart, 1);
        setMenuCart(updatedCart);
      }
    }
  };

  function incrementCounterAndAddToCart(index1, index2, index3) {
    if (index2 === undefined && index3 === undefined) {
      // If index2 and index3 are undefined, update menu item at index1
      const list = [...menuCart];
      const updatedMenuItem = list[index1];
      // Check if the item already exists in menuCart
      const existingItemIndex = menuCart.findIndex(
        (item) => item.id === updatedMenuItem.id
      );

      if (existingItemIndex > 1) {
        // If the item exists, update the counter
        const updatedMenuCart = [...menuCart];
        updatedMenuCart[existingItemIndex].counter += 1;
        setMenuCart(updatedMenuCart);
      } else {
        // If the item doesn't exist, add it to menuCart
        setMenuCart((prevState) => [
          ...prevState,
          {
            category_id: updatedMenuItem.category_id,
            category_name: updatedMenuItem.category_name,
            product: [
              [
                {
                  id: updatedMenuItem.id,
                  counter: 1,
                  name: updatedMenuItem.name,
                  price: updatedMenuItem.price,
                  grab_price: updatedMenuItem.grab_price,
                  foodpanda_price: updatedMenuItem.foodpanda_price,
                  pricelist: priceType,
                  remarks: updatedMenuItem.remarks,
                },
              ],
            ],

            // Add other properties of the item as needed
          },
        ]);
      }
      // Update the counter in the menu state
      updatedMenuItem["counter"] = parseInt(updatedMenuItem["counter"] + 1);
      setMenuCart(list);
      // emitEvent()
    } else {
      const list = [...menu];
      const updatedMenuItem = list[index1]["products"][index2][index3];
      // Check if the item already exists in menuCart
      const existingItemIndex = menuCart.findIndex(
        (item) => item.id === updatedMenuItem.id
      );

      if (existingItemIndex !== -1) {
        // If the item exists, update the counter
        const updatedMenuCart = [...menuCart];
        updatedMenuCart[existingItemIndex].counter += 1;
        setMenuCart(updatedMenuCart);
      } else {
        // If the item doesn't exist, add it to menuCart
        setMenuCart((prevState) => [
          ...prevState,
          {
            id: updatedMenuItem.id,
            counter: 1,
            name: updatedMenuItem.name,
            price: updatedMenuItem.price,
            grab_price: updatedMenuItem.grab_price,
            foodpanda_price: updatedMenuItem.foodpanda_price,
            pricelist: priceType,
            remarks: updatedMenuItem.remarks,
            // Add other properties of the item as needed
          },
        ]);
      }
      // Update the counter in the menu state
      updatedMenuItem["counter"] = parseInt(updatedMenuItem["counter"] + 1);
      setMenu(list);
      // emitEvent()
    }
  }

  function decrementCounterAndRemoveFromCart(index1, index2, index3) {
    const list = [...menu];
    list[index1]["products"][index2][index3]["counter"] -= 1;
    setMenu(list);
    const selectedItem = list[index1]["products"][index2][index3];
    const itemIndexInCart = menuCart.findIndex(
      (cartItem) => cartItem.id === selectedItem.id
    );
    if (itemIndexInCart !== -1) {
      // Item exists in the cart, update its counter
      const updatedCart = [...menuCart];
      updatedCart[itemIndexInCart].counter -= 1;
      if (updatedCart[itemIndexInCart].counter <= 0) {
        // If counter becomes zero or negative, remove the item from the cart
        updatedCart.splice(itemIndexInCart, 1);
      }
      setMenuCart(updatedCart);
      // emitEvent()
    }
  }

  function removeFromCart(index) {
    setMenuCart((prevCart) => {
      const removedItem = prevCart[index];
      const newCart = [...prevCart];
      newCart.splice(index, 1);
      // Update the counter in the menu state
      setMenu((prevMenu) => {
        const updatedMenu = [...prevMenu];
        const categoryIndex = updatedMenu.findIndex((category) =>
          category.products.some((product) =>
            product.some((item) => item.id === removedItem.id)
          )
        );

        if (categoryIndex !== -1) {
          const productIndex = updatedMenu[categoryIndex].products.findIndex(
            (product) => product.some((item) => item.id === removedItem.id)
          );

          if (productIndex !== -1) {
            const itemIndex = updatedMenu[categoryIndex].products[
              productIndex
            ].findIndex((item) => item.id === removedItem.id);

            if (itemIndex !== -1) {
              updatedMenu[categoryIndex].products[productIndex][
                itemIndex
              ].counter = 0;
            }
          }
        }
        return updatedMenu;
      });
      return newCart;
    });
    // emitEvent()
  }

  function handleModifierOrder(type, e, menu_modifier) {
    if(type === "addons"){
      const {value, checked } = e.target

      setModifierOrder((prevState) => {
        let updatedItems = prevState.modifier;

        if (checked) {
          updatedItems = [...updatedItems, menu_modifier];
        } else {
          // Remove item if unchecked
          updatedItems = updatedItems?.filter((item) => item.id !== value);
        }

        return { ...prevState, modifier: updatedItems };
      });
    } else if(type === "add") {
      setModifierOrder((prev) => ({
        ...prev,
        counter: parseInt(prev.counter || 0) + 1,
      }));
    } else if(type === "minus") {
      if(modifierOrder?.counter > 0){
        setModifierOrder((prev) => ({
          ...prev,
          counter: parseInt(prev.counter || 0) - 1,
        }));
      }
    } else if(type === "input"){
      setModifierOrder((prev) => ({
        ...prev,
        counter: e.target.value,
      }));
    }
  }
  function handleAddModifierOrder() {
    let order = {};

    const areArraysEqual = (arr1, arr2) => {
      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false; // Check if both are arrays
      if (arr1.length !== arr2.length) return false; // Check if lengths are equal
      return arr1.every((item) => arr2.includes(item)); // Compare contents
    };
  
    if (modifierOrder && modifierOrder.modifier) {
      let totalAmount = modifierOrder.modifier.reduce((sum, item) => {
        const amount = parseFloat(item.price);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);

      let totalModifierId = modifierOrder.modifier.reduce((sum, item) => {
        const amount = parseInt(item.modifier_id);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
  
      const count = modifierOrder.counter || 0;
      const mod = modifierOrder.modifier || [];
      const total_order = (parseFloat(modifierData.price) + parseFloat(totalAmount)) || 0;

      order = {
        ...modifierData,
        counter: count,
        addons: mod,
        pricelist: priceType,
        // is_additional: showAddItem ? true : false,
        with_modifier_total: `${total_order.toFixed(2)}`,
        [priceType + "_price"]: `${total_order.toFixed(2)}`,
        with_modifier_id: `${parseInt(totalModifierId) + parseInt(modifierData.id)}`,
      };

      setMenuCart((prevState) => {
        const orderExistsIndex = prevState.findIndex(
          (existingOrder) => (existingOrder.id === order.id) && areArraysEqual(existingOrder?.addons, order?.addons)
        );

        if (orderExistsIndex === -1) {
          return [...prevState, order];
        } else {
          const updatedOrderCart = [...prevState];
          const existingOrder = updatedOrderCart[orderExistsIndex];
      
          const updatedCounter = existingOrder.counter + order.counter;
          const updatedTotal = (parseFloat(modifierData.price) + parseFloat(totalAmount)) || 0;
      
          updatedOrderCart[orderExistsIndex] = {
            ...existingOrder,
            counter: updatedCounter,
            with_modifier_total: `${updatedTotal.toFixed(2)}`,
          };
      
          return updatedOrderCart;
        }
      });
      setModifierOrder((prev) => ({
        ...prev,
        counter: 0
      }))
      setOpenModifier(false)
    }

    // if (showAddItem) {
      
    //   const addItemIndex = additionalItems.findIndex(
    //     (item) => item.id === modifierOrder.id && item.pricelist === priceType
    //   );

    //   if (addItemIndex === -1) {
    //     setAdditionalItems([...additionalItems, order]);
    //   } else {
    //     setAdditionalItems((prevState) => {
    //       const updatedOrderCart = [...prevState];
    //       const existingOrder = updatedOrderCart[addItemIndex];
      
    //       const updatedCounter = existingOrder.counter + order.counter;
    //       const updatedTotal = (parseFloat(modifierData.price) + parseFloat(totalAmount)) || 0;
      
    //       updatedOrderCart[addItemIndex] = {
    //         ...existingOrder,
    //         counter: updatedCounter,
    //         with_modifier_total: `${updatedTotal.toFixed(2)}`,
    //       };
      
    //       return updatedOrderCart;
    //     });
    //   }
    // }
  }

  const handleBulkPrintRef = (ref) => {
    bulkPrintRefs.current.push(ref);
  };

  function renderOrderSlips() {
    return (
      <div className="hide-from-screen">
        {orderSlips && Object.keys(orderSlips).map((key, index) => {
          return (
            <div key={index}>
              <DispatchSlip
                includeItemRemarks
                // restoType={loggedInResto}
                purpose="order slip"
                printerName={key}
                table={buzzer.id}
                orderItems={orderSlips[key]}
                setBulkPrintRef={handleBulkPrintRef}
                pageAction={action}
              />
            </div>
          );
        })}
      </div>
    );
  }


  const [printingInProgress, setPrintingInProgress] = useState(false);
  // const [printSlipsDone, setPrintSlipsDone] = useState(false);

  async function printMultipleOrderSlips(passedOrderSlips) {
    setPrintingInProgress(true);
    const printerArray = Object.keys(passedOrderSlips);
    return new Promise((resolve, reject) => {
      const promises = printerArray.map((printerName, index) => {
        return new Promise((innerResolve, innerReject) => {
          if (bulkPrintRefs.current[index]) {
            const element = bulkPrintRefs.current[index];
            html2canvas(element, { 
              scale: 1, 
            })
              .then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                setTimeout(() => {
                  printOrderSlip(imgData, printerName, () => {
                    innerResolve();
                  });
                }, 2000);
              })
              .catch((error) => {
                innerReject(error);
              });
          } else {
            innerResolve();
          }
        });
      });

      Promise.all(promises)
        .then(() => {
          resolve();
          // setPrintSlipsDone(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async function printOrderSlip(image, printerName, callback) {
    const response = await printBase64(printerName, image, "0");
    if (response.data) {
      setTimeout(() => {
        callback();
        // refreshPage();
          setTimeout(() => {
            navigate("/add-payment/" + newOrderId, {
                state: { inactive: false, active: false, type: priceType },
              });
        }, 1500)
      }, 1000);
    } else {
      // printOrderSlip(image, printerName, callback);
    }
  }

  async function orderNow() {
    if (!disableClick) {
      recordUserActivityLog(
        `Added new order on buzzer no.${buzzer.id} with a total amount of ${numberWithCommas(parseFloat(priceType === "store" ? grandTotal : priceType === "grab"? grandTotalgrab : grandTotalfd).toFixed(2))}`
      );
      setAction("order");
      setDisableClick(true);
      localStorage.removeItem("order_id");
      const response = await createOrderTakeout(menuCart, priceType, buzzer, 'dine-in');
      if (response.data) {
        const responseInfo = response.data.message;
        localStorage.setItem("order_id", JSON.stringify(responseInfo.order_id));
        // setOrderSlips(responseInfo.order_slips);
        // setBuzzer({
        //   id: responseInfo.buzzer_no,
        //   name: responseInfo.buzzer_no,
        // })
        toast.success(responseInfo.message, {
          style: toastStyle(),
        });
        setTimeout(() => {
            navigate("/add-payment/" + responseInfo.order_id, {
                state: { inactive: false, active: false, type: priceType },
              });
        }, 1500)
      } else {
        setDisableClick(false);
      }
    }
  }

  // logout handler
  async function handleEndOfZ() {
    recordUserActivityLog(
      `Clicked Order Now but Today's Transaction Already Ended`
    );
    toast.error("Today's transaction has already ended.");
  }

  const handleNavbar = (e) => {
    const { 
      name, 
      // value 
    } = e.target;
    if (name === "category") {
      recordUserActivityLog(
        `Clicked Category Report in the Horizontal Navbar`
      );
      navigate("/category-report", { state: { name: "cashier" } });
    } else if (name === "closed-inv") {
      recordUserActivityLog(
        `Clicked Closed Invoice in the Horizontal Navbar`
      );
      navigate("/closedinvoices", { state: { name: "cashier" } });
    } else if (name === "cash-count") {
      recordUserActivityLog(
        `Clicked Add Cash Count in the Horizontal Navbar`
      );
      navigate("/add-cash-count", { state: { name: "cashier" } });
    } else if (name === "z") {
      recordUserActivityLog(
        `Clicked Z-Reading in the Horizontal Navbar`
      );
      navigate("/z-reading-report", { state: { name: "cashier" } });
    } else if (name === "logout") {
      recordUserActivityLog(
        `Clicked Logout in the Horizontal Navbar`
      );
      handleLogout();
    } else if (name === "x") {
      recordUserActivityLog(
        `Clicked X-Reading in the Horizontal Navbar`
      );
      navigate("/x-reading-report", { state: { name: "cashier" } });
    } else if (name === "cash-drawer") 
    {
      recordUserActivityLog(
        `Clicked Open Cash Drawer in the Horizontal Navbar`
      );
      printBase64DataForCashDrawer();
    }
  };

  async function printBase64DataForCashDrawer() {
    const response = await printOpenCashDrawer(window.printer_name, "0");
    if (response.data) {
    } else {
    }
  }

  const handleOpenModifier = (data) => {
    setModifierData({
      ...data,
      addons: data.menu_modifiers
    })
    setModifierOrder((prev) => ({
      ...prev,
      modifier:[]
    }))
    setOpenModifier(true)
  }

  useEffect(() => {
    var grandTotal = 0;
    var grandTotalfd = 0;
    var grandTotalgrab = 0;
    menuCart.forEach((data) => {
      grandTotal += parseInt(data.counter) * (data?.with_modifier === "1" ? parseFloat(data?.with_modifier_total) : parseFloat(data?.price));
      grandTotalfd += data.counter * data.foodpanda_price;
      grandTotalgrab += data.counter * data.grab_price;
    });

    setGrandTotal(grandTotal);
    setGrandTotalfd(grandTotalfd);
    setGrandTotalgrab(grandTotalgrab);
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu, menuCart]);

  useEffect(() => {
    fetchCategories();
    localStorage.removeItem("item_discount_type");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (orderSlips && Object.keys(orderSlips).length > 0) {
      renderOrderSlips();
      setTimeout(() => {
        printMultipleOrderSlips(orderSlips);
      }, 2000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSlips]);

  useEffect(() => {
    const socket = new WebSocket(window.websocket_ip);
    setWs(socket);
    return () => {
      socket.close();
    };
  }, []);
  const discountTotal = {};
  // const grandDiscountTotal = '';
  useEffect(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({menuCart: menuCart, computedDiscount: discountTotal,}));
    } else {
      console.warn("WebSocket is not open. Cannot send message.");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuCart, ws]);


  return (
    <div className="page redo-overflow-hidden">
      <div
        className={
          getRole() === "1"
            ? "redo-container-manager redo-overflow-hidden"
            : "redo-container redo-overflow-hidden"
        }
      >
        <Row>
          <Col
            xl={8}
            lg={8}
            md={8}
            sm={8}
            xs={8}
            className={
              getRole() === "1" ? "redo-menu-cont-manager" : "redo-menu-cont"
            }
          >
            <Row>
              <Col 
                xl={4}
                lg={4}
                md={4}
                sm={4}
                xs={4} 
                className="align-left"
              >
                <button
                  className={
                    priceType === "store"
                      ? "categories-btn-clicked"
                      : "categories-btn"
                  }
                  onClick={() => setPriceType("store")}
                >
                  STORE
                </button>
              </Col>
              <Col 
                xl={4}
                lg={4}
                md={4}
                sm={4}
                xs={4} 
                className="align-left"
              >
                <button
                  disabled={true}
                  className={
                    priceType === "foodpanda"
                      ? "categories-btn-cat-fd-clicked"
                      : "categories-btn-cat-fd"
                  }
                  onClick={() => setPriceType("foodpanda")}
                >
                  FOOD PANDA
                </button>
              </Col>
              <Col 
                xl={4}
                lg={4}
                md={4}
                sm={4}
                xs={4} 
                className="align-left"
              >
                <button
                  disabled={true}
                  className={
                    priceType === "grab"
                      ? "categories-btn-grab-clicked"
                      : "categories-btn-grab"
                  }
                  onClick={() => setPriceType("grab")}
                >
                  GRAB
                </button>
              </Col>
            </Row>
            <Row className="pt-4">
              {categories.map((data) => (
                <Col 
                  xl={3}
                  lg={3}
                  md={3}
                  sm={3}
                  xs={3} 
                  key={data.id} 
                  className="align-center"
                >
                  <button
                    className={
                      priceType === "store"
                        ? categoryType === data.id
                          ? "categories-btn-cat-clicked"
                          : "categories-btn-cat"
                        : priceType === "foodpanda"
                        ? categoryType === data.id
                          ? "categories-btn-fd-clicked"
                          : "categories-btn-fd"
                        : categoryType === data.id
                        ? "categories-btn-cat-clicked-grab"
                        : "categories-btn-cat-grab"
                    }
                    onClick={(e) => filterMenu(data.id)}
                  >
                    {data.name}
                  </button>
                </Col>
              ))}
              {/* <Col 
                xl={3}
                lg={3}
                md={3}
                sm={3}
                xs={3}  
                className="align-center"
              >
                <button
                  className={
                    priceType === "store"
                      ? "categories-btn-empty"
                      : priceType === "grab"
                      ? "categories-btn-empty-grab"
                      : "categories-btn-empty-fd"
                  }
                >
                  {"sdhjvbdshj"}
                </button>
              </Col>
              <Col 
                xl={3}
                lg={3}
                md={3}
                sm={3}
                xs={3} 
                className="align-center"
              >
                <button
                  className={
                    priceType === "store"
                      ? "categories-btn-empty"
                      : priceType === "grab"
                      ? "categories-btn-empty-grab"
                      : "categories-btn-empty-fd"
                  }
                >
                  {"hdfgvdef"}
                </button>
              </Col> */}
            </Row>
            <Row>
              <Col sm={12}>
                {menu.map((category, index1) => {
                  return (
                    <section key={index1}>
                      <Row className="my-1">
                        {category.products.map((product, index2) => {
                          return product
                            .filter((items) => items.qty > 0)
                            .map((info, index3) => {
                              return (
                                <Col
                                  xl={4}
                                  lg={4}
                                  md={4}
                                  sm={4}
                                  xs={4}
                                  className="pt-1 py-1 d-flex justify-content-center"
                                  key={index3}
                                >
                                  <Card
                                    className={
                                      priceType === "store"
                                        ? "card store-card"
                                        : priceType === "grab"
                                        ? "grab-card"
                                        : "foodpanda-card"
                                    }
                                  >
                                    <Card.Body>
                                      <Row>
                                        <Col>
                                          <Card.Subtitle>
                                            <strong
                                              className={
                                                priceType === "store"
                                                  ? "card-subtitle"
                                                  : "card-subtitle-1"
                                              }
                                            >
                                              {info.name}
                                            </strong>
                                          </Card.Subtitle>
                                          <h6 className="pt-2">
                                            <strong
                                              className={
                                                priceType === "store"
                                                  ? "card-subtitle"
                                                  : "card-subtitle-1"
                                              }
                                            >
                                              {" "}
                                              ₱{" "}
                                              {priceType === "store"
                                                ? info.price
                                                : priceType === "grab"
                                                ? info.grab_price
                                                : info.foodpanda_price}
                                            </strong>
                                          </h6>
                                        </Col>
                                        {/* {
                                          info.file_url && (
                                            <Col>
                                              <Image
                                                src={info.file_url}
                                                alt="Uploaded File"
                                                className="menu-image"
                                              />
                                            </Col>
                                          )
                                        } */}
                                      </Row>
                                    </Card.Body>
                                    {
                                      info?.with_modifier === "1" ? (
                                        <>
                                          <Card.Footer>
                                            {/* {info.qty > 0 ? ( */}
                                              <Row>
                                                <Col 
                                                  className="d-flex justify-content-center modifier-width"
                                                >
                                                  <Button
                                                    onClick={() => handleOpenModifier(info)}
                                                    className="modifier-btn"
                                                  >
                                                    <Space>
                                                      <AddBoxIcon/>
                                                      MODIFIERS
                                                    </Space>
                                                  </Button>
                                                </Col>
                                              </Row>
                                            {/* ) : (
                                              <Row>
                                                <Col className="d-flex justify-content-center">
                                                  <button className="new-order-btn">
                                                    OUT OF STOCK
                                                  </button>
                                                </Col>
                                              </Row>
                                            )} */}
                                          </Card.Footer>
                                        </>
                                      ) : (
                                        <>
                                          <Card.Footer>
                                            {info.qty > 0 ? (
                                              <Row>
                                                <Col 
                                                  xl={4}
                                                  lg={4}
                                                  md={3}
                                                  sm={3}
                                                  xs={3}
                                                  className="d-flex justify-content-center"
                                                >
                                                  {parseInt(info.counter) >= 1 ? (
                                                    <button
                                                      className={
                                                        priceType === "store"
                                                          ? "redo-minus-plus-btn"
                                                          : "redo-minus-plus-btn-grab"
                                                      }
                                                      style={{ fontSize: "30px" }}
                                                      onClick={() =>
                                                        decrementCounterAndRemoveFromCart(
                                                          index1,
                                                          index2,
                                                          index3
                                                          // menuItems,
                                                          // type
                                                        )
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className={
                                                        priceType === "store"
                                                          ? "redo-minus-plus-btn"
                                                          : "redo-minus-plus-btn-grab"
                                                      }
                                                      style={{ fontSize: "30px" }}
                                                      disabled
                                                    >
                                                      -
                                                    </button>
                                                  )}
                                                </Col>
                                                <Col 
                                                  xl={4}
                                                  lg={4}
                                                  md={5}
                                                  sm={5}
                                                  xs={5}
                                                  className="d-flex justify-content-center"
                                                >
                                                  <Form.Control
                                                    value={info.counter}
                                                    type="number"
                                                    // disabled
                                                    className="text-center"
                                                    onChange={(e) =>
                                                      handleCounterChange(
                                                        e.target.value,
                                                        index1,
                                                        index2,
                                                        index3,
                                                        info.id,
                                                        info
                                                      )
                                                    }
                                                  />
                                                </Col>
                                                <Col 
                                                  xl={4}
                                                  lg={4}
                                                  md={3}
                                                  sm={3}
                                                  xs={3}
                                                  className="d-flex justify-content-center"
                                                >
                                                  <button
                                                    className={
                                                      priceType === "store"
                                                        ? "redo-minus-plus-btn"
                                                        : "redo-minus-plus-btn-grab"
                                                    }
                                                    style={{ fontSize: "20px" }}
                                                    onClick={() =>
                                                      incrementCounterAndAddToCart(
                                                        index1,
                                                        index2,
                                                        index3
                                                        // menuItems,
                                                        // type
                                                      )
                                                    }
                                                  >
                                                    +
                                                  </button>
                                                </Col>
                                              </Row>
                                            ) : (
                                              <Row>
                                                <Col className="d-flex justify-content-center">
                                                  <button className="new-order-btn">
                                                    OUT OF STOCK
                                                  </button>
                                                </Col>
                                              </Row>
                                            )}
                                          </Card.Footer>
                                        </>
                                      )
                                    }
                                  </Card>
                                </Col>
                              );
                            });
                        })}
                      </Row>
                    </section>
                  );
                })}
              </Col>
            </Row>
          </Col>
          <Col
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={4}
            className={
              getRole() === "1"
                ? "redo-order-status-cont-manager"
                : "redo-order-status-cont"
            }
          >
            <Row>
              <Col>
                <label className="redo-title pt-2">Order Status</label>
              </Col>
              {(getRole() === "1" || getRole() === "7") && (
                <Col xl={3} className="d-flex justify-content-end">
                  <button
                    className="back-btn"
                    onClick={() => navigate("/closedinvoices")}
                  >
                    BACK
                  </button>
                </Col>
              )}
            </Row>
            <Row className="p-1">
              <hr />
              <Col xl={5} lg={5} md={5} sm={5} xs={5}>
                <h5>ITEMS</h5>
              </Col>
              <Col xl={2} lg={2} md={2} sm={2} xs={2} className="align-center">
                <h5>QTY</h5>
              </Col>
              <Col xl={3} lg={3} md={3} sm={3} xs={3} className="align-right">
                <h5>TOTAL</h5>
              </Col>
              <Col xl={2} lg={2} md={2} sm={2} xs={2}></Col>
            </Row>
            <Row
              className={
                getRole() === "1"
                  ? "redo-order-status-items-cont-manager"
                  : "redo-order-status-items-cont"
              }
            >
              <Col>
                {menuCart.map((data, index) => {
                  return (
                    <>
                      <Row className="pt-1" key={index}>
                        <Col xl={5} lg={5} md={5} sm={5} xs={5}>
                          <label>{data.name}</label>
                          {
                          data.menu_details && data.menu_details?.length !== 0 && (
                            <>
                              {
                                data.menu_details.map((data) => (
                                  <Row className="ms-4">
                                    {data?.name}
                                  </Row>
                                ))
                              }
                            </>
                          )
                        }
                        {
                          data?.with_modifier === "1" && (
                            <>
                              {
                                data.addons.map((data) => (
                                  <Row className="ms-4">
                                    {data?.modifier_name} - {data.price}
                                  </Row>
                                ))
                              }
                            </>
                          )
                        }
                        </Col>
                        <Col
                          xl={2}
                          lg={2}
                          md={2}
                          sm={2}
                          xs={2}
                          className="align-center"
                        >
                          <label>{data.counter}</label>
                        </Col>
                        <Col
                          xl={3}
                          lg={3}
                          md={3}
                          sm={3}
                          xs={3}
                          className="align-right"
                        >
                          {priceType === "store" && (
                            <label>
                              {
                                !data?.with_modifier || data.with_modifier === "0" ? (
                                  numberWithCommas(
                                    parseFloat(parseFloat(data.price) * parseInt(data.counter)).toFixed(2)
                                  )
                                ) : (
                                  numberWithCommas(
                                    parseFloat(parseFloat(data.with_modifier_total) * parseInt(data.counter)).toFixed(2)
                                  )
                                )
                              }
                            </label>
                          )}
                          {priceType === "grab" && (
                            <label>
                              {numberWithCommas(
                                parseFloat(
                                  parseFloat(data.grab_price) *
                                    parseInt(data.counter)
                                ).toFixed(2)
                              )}
                            </label>
                          )}
                          {priceType === "foodpanda" && (
                            <label>
                              {numberWithCommas(
                                parseFloat(
                                  parseFloat(data.foodpanda_price) *
                                    parseInt(data.counter)
                                ).toFixed(2)
                              )}
                            </label>
                          )}
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                          <Space>
                            <img
                              alt=""
                              src={trash}
                              className=""
                              onClick={() => removeFromCart(index)}
                            ></img>
                            <EditOutlined
                              onClick={() => {
                                setTempRemarks(data.remarks);
                                setOrderCartIndex(index);
                                setOpenRemarksModal(true);
                              }}
                            />
                          </Space>
                        </Col>
                      </Row>
                      {data.remarks && !isEmptyString(data.remarks) && (
                        <Row className="item-remarks-container">
                          <EditNoteOutlined className="item-remarks-icon" />
                          {data.remarks}
                        </Row>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
            <Row>
              <Col>
                <Row className=" ">
                  <Col className="d-flex justify-content-left redo-title">
                    <h2>TOTAL:</h2>
                  </Col>
                  <Col className=" d-flex justify-content-end text-right redo-title">
                    <h2>
                      {numberWithCommas(
                        parseFloat(
                          priceType === "store"
                            ? grandTotal
                            : priceType === "grab"
                            ? grandTotalgrab
                            : grandTotalfd
                        ).toFixed(2)
                      )}
                    </h2>
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center text-center">
                  {getZReading() === "no" ? (
                      <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <button
                          type="submit"
                          className="order-now-btn"
                          onClick={() => orderNow()}
                          // onClick={() => setOpenBuzzerModal(true)}
                          disabled={menuCart.length===0}
                        >
                          ORDER NOW 
                        </button>
                      </Col>
                  ) : (
                    <Col xl={8} lg={8} md={8} sm={8} xs={8}>
                      <button
                        type="submit"
                        className="order-now-btn"
                        onClick={handleEndOfZ}
                      >
                        ORDER NOW
                      </button>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
       {/* ADD REMARKS PER ORDERED ITEM */}
       <Modal
          open={openRemarksModal}
          onCancel={() => setOpenRemarksModal(false)}
          closeIcon={false}
          footer={null}
          centered
          title="Item Remarks"
        >
        <TextArea
          value={tempRemarks}
          placeholder="Enter remarks"
          onChange={(e) => {
            setTempRemarks(e.target.value);
          }}
        />
        <Space className="d-flex justify-content-end w-100 p-0 mt-4">
          <Button
            // className="me-2 px-4 py-3"
            className="remove-btn"
            onClick={() => {
              setOpenRemarksModal(false);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="login-btn"
            onClick={() => {
              const newOrderCart = [...menuCart];
              newOrderCart[orderCartIndex].remarks = tempRemarks;
              setMenuCart(newOrderCart);
              setOpenRemarksModal(false);
            }}
          >
            SAVE
          </Button>
        </Space>
      </Modal>
      {/* <Modal
        open={openBuzzerModal}
        onCancel={() => setOpenBuzzerModal(false)}
        closeIcon={false}
        footer={null}
        centered
        className="buzzer-modal"
        title="Choose Buzzer Number"
      >
        <Row>
          <Col align="center">
            <Select 
              placeholder="Select a Buzzer Number" 
              className=""
              // onChange={(e) => handleRentalUnit(e)} 
              showSearch
              filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {buzzerNumber?.map((option) => (
                <Option key={option.id} value={option.id}>{option.name}</Option>
              ))}
            </Select>
          </Col>
        </Row>
        {
          renderTableOptions()
        }
        <Space className="d-flex justify-content-end w-100 p-0 mt-4">
          <Button
            // className="me-2 px-4 py-3"
            className="remove-btn"
            onClick={() => {
              setOpenBuzzerModal(false);
              setBuzzer('')
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="login-btn"
            onClick={() => orderNow()}
            disabled={buzzer === ""}
          >
            SAVE
          </Button>
        </Space>
      </Modal> */}
      <Modal
        open={openModifier}
        onCancel={() => {
            setOpenModifier(false);
          }
        }
        closeIcon={false}
        footer={null}
        maskClosable={false}
        className="modifier-modal"
      >
        <Row className="mb-4">
          <Col xs={8} className="modifier-title">
            Select Modifier
          </Col>
          <Col xs={4} align="end">
            <Row align="end">
              <Col align="end" className="text-center vertical-center">
                <MinusCircleFilled
                  onClick={() =>
                    handleModifierOrder("minus")
                  }
                  className={`modifier-icon ${priceType}-icon`}
                />
              </Col>
              <Col className="text-center">
                <Input
                  className="modifier-input-field text-center"
                  value={modifierOrder.counter}
                  onChange={(e) =>
                    handleModifierOrder("input", e)
                  }
                />
              </Col>
              <Col className="text-center vertical-center">
                <PlusCircleFilled
                  onClick={() =>
                    handleModifierOrder("add")
                  }                  
                  className={`modifier-icon ${priceType}-icon`}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {
            modifierData?.addons?.map((data) => (
              <Col span={6}>
                <input
                  id={data?.id}
                  class="checkbox-custom"
                  name={data?.modifier_name}
                  value={data?.id}
                  type="checkbox"
                  onChange={(e) => handleModifierOrder("addons", e, data)}
                  checked={modifierOrder?.modifier?.some(item => item.modifier_id === data?.modifier_id)}
                />
                <label for={data?.id} class="checkbox-custom-label">
                  {data?.modifier_name.toUpperCase()}
                </label>
              </Col>
            ))
          }
        </Row>
        <Space className="d-flex justify-content-end w-100 p-0 mt-4">
          <Button
            // className="me-2 px-4 py-3"
            onClick={() => {
              setOpenModifier(false);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            // className="px-4 py-3"
            disabled={modifierOrder && parseInt(modifierOrder?.counter) === 0}
            onClick={() => {
              handleAddModifierOrder()
              // setOpenModifier(false);
            }}
          >
            ADD
          </Button>
        </Space>
      </Modal>
      <Modal
        maskClosable={false}
        open={printingInProgress}
        footer={null}
        closeIcon={false}
      >
        <Row className="d-flex justify-content-center">
          <Title level={5}>PRINTING IN PROGRESS</Title>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large" />
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </Modal>
      <div>{renderOrderSlips()}</div>

      {getRole() !== "1" && (
        <div className="redo-footer-container">
          <Row>
            <Col className="d-flex justify-content-center">
              {/* <img alt="" src={cat} style={{cursor: "pointer"}} name="category" ></img> */}
            </Col>
            <Col className="d-flex justify-content-center">
              {/* <img alt="" src={ci} style={{cursor: "pointer"}} name="closed-inv" ></img> */}
            </Col>
            <Col className="d-flex justify-content-center">
              <img alt="" src={cc} style={{cursor: "pointer"}} name="cash-count" onClick={(e)=>handleNavbar(e)}></img>
            </Col>
            <Col className="d-flex justify-content-center">
              <img
                alt=""
                src={drawer}
                style={{ cursor: "pointer" }}
                name="cash-drawer"
                onClick={(e) => handleNavbar(e)}
              ></img>
            </Col>
            <Col className="d-flex justify-content-center">
              <img
                alt=""
                src={logout}
                style={{ cursor: "pointer" }}
                name="logout"
                onClick={(e) => handleNavbar(e)}
              ></img>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              {/* <label style={{color: "#ffffff", cursor: "pointer"}}  name="category" onClick={(e)=>handleNavbar(e)}>Category Report</label> */}
            </Col>
            <Col className="d-flex justify-content-center">
              {/* <label style={{color: "#ffffff", cursor: "pointer"}} name="closed-inv" onClick={(e)=>handleNavbar(e)}>Closed Invoices</label>  */}
            </Col>
            <Col className="d-flex justify-content-center">
              {/* <label style={{color: "#ffffff", cursor: "pointer"}} name="cash-count" onClick={(e)=>handleNavbar(e)}>Cash Count</label> */}
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}
